var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveFriend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2497 29C22.508 29 21.017 28.3962 19.7768 27.1885C18.5365 25.9809 17.9163 24.5292 17.9163 22.8333C17.9163 21.1375 18.5365 19.6858 19.7768 18.4781C21.017 17.2705 22.508 16.6667 24.2497 16.6667C25.9913 16.6667 27.4823 17.2705 28.7226 18.4781C29.9629 19.6858 30.583 21.1375 30.583 22.8333C30.583 24.5292 29.9629 25.9809 28.7226 27.1885C27.4823 28.3962 25.9913 29 24.2497 29ZM11.583 38.25V37.0167C11.583 36.143 11.8142 35.3404 12.2765 34.6086C12.7388 33.8768 13.3521 33.3177 14.1163 32.9312C15.7525 32.1347 17.415 31.5376 19.1038 31.1398C20.7927 30.7421 22.508 30.5427 24.2497 30.5417C25.9913 30.5406 27.7066 30.74 29.3955 31.1398C31.0844 31.5396 32.7469 32.1368 34.383 32.9312C35.1483 33.3167 35.7621 33.8758 36.2244 34.6086C36.6868 35.3414 36.9174 36.1441 36.9163 37.0167V38.25C36.9163 39.0979 36.6065 39.824 35.9869 40.4284C35.3673 41.0327 34.6216 41.3344 33.7497 41.3333H14.7497C13.8788 41.3333 13.1336 41.0317 12.514 40.4284C11.8944 39.8251 11.5841 39.0989 11.583 38.25Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.6455,
    y: 26.3317,
    width: 10.7324,
    height: 3.57748,
    rx: 1.78874,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFriend);
export default __webpack_public_path__ + "static/media/removeFriend.dc127c62d9b37173f1fd5078278cd94c.svg";
export { ForwardRef as ReactComponent };